// @ts-nocheck
import React, {Component} from 'react';
import AddHCOP1 from './AddHco_P1'
import AddHCOP2 from './AddHco_P2'
import AddHCOP3 from './AddHco_P3'
import AddHCOSuccess from './AddHcoSuccess'
import Popup from '../../../globalcomponents/Popup';



class AddHCO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: [],
            activePage: 0,
            info: {},
            loaded: false
        };
    }

    componentDidMount() {
        this.setState({
            page: [
                <AddHCOP1 user={this.props.user} info={this.state.info} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
                <AddHCOP2 user={this.props.user} info={this.state.info} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
                <AddHCOP3 user={this.props.user} info={this.state.info} submit={this.props.submit} nextPage={this.nextPage.bind(this)} close={this.props.close} />,
                <AddHCOSuccess close={this.props.close} />,
            ],
            loaded: true
        })
    }

    nextPage(i, info) {
        //console.log(i);
        if (info !== undefined) {
            let temp = this.state.info
            Object.assign(temp, info)
            this.setState({
                activePage: i,
                info: temp
            });
        }
        else {
            this.setState({
                activePage: i
            });
        }
    }

    render() {
        return (
            <div>
                {this.state.loaded > 0 ? <Popup component={this.state.page[this.state.activePage]} /> : ""}
            </div>
        )
    }
}

export default AddHCO;
